import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import cls from './lighting.module.scss';

export type LightingClassNames = Partial<Record<'root' | 'wrapper', string>>;

export type LightingProps = {
	enabled?: boolean;
	classNames?: LightingClassNames;
	withoutBorder?: boolean;
} & ComponentPropsWithoutRef<'div'>;

export const Lighting = forwardRef<HTMLDivElement, LightingProps>(
	({ enabled, children, className, classNames, withoutBorder, ...props }, ref) => (
		<div
			{...props}
			ref={ref}
			className={clsx(cls.lighting, className, classNames?.root)}
			data-enabled={enabled || undefined}
			data-no-border={withoutBorder || undefined}
		>
			<span className={clsx(cls.lightingWrapper, classNames?.wrapper)} />
			{children}
		</div>
	),
);

Lighting.displayName = 'Lighting';
